import { translate } from '@/services/translations'

const $gettext = translate.gettext.bind(translate)

/**
 * General
 */

const OTHER = 'OTHER'

/**
 * Request Statuses
 */
const STARTED = 'STARTED'
const SUBMITTED = 'SUBMITTED'
const DECLINED = 'DECLINED'
const APPROVED = 'APPROVED'
const PARTIALLY_APPROVED = 'PARTIALLY_APPROVED'
const PARTIALLY_APPROVED_PENDING = 'PARTIALLY_APPROVED_PENDING'
const SUBMITTED_NEW = 'SUBMITTED_NEW'
const SUBMITTED_AWAITING_USER_REPLY = 'SUBMITTED_AWAITING_USER_REPLY'
const SUBMITTED_AWAITING_ADMIN_REPLY = 'SUBMITTED_AWAITING_ADMIN_REPLY'

const REQUEST_STATUS_LIST = [
  STARTED,
  SUBMITTED,
  DECLINED,
  APPROVED,
  PARTIALLY_APPROVED,
  PARTIALLY_APPROVED_PENDING,
]

const PAYPAL = 'PAYPAL'
const WISE = 'WISE'
const PAYOUT_TYPE_LIST = [PAYPAL, OTHER, WISE]
const PAYOUT_TYPE_CHOICES = [
  { value: PAYPAL, label: 'PayPal' },
]

const OPEN_REQUEST_STATUSES = [STARTED, SUBMITTED, PARTIALLY_APPROVED_PENDING]
const CLOSED_REQUEST_STATUSES = [DECLINED, APPROVED, PARTIALLY_APPROVED]

// Use this for dropdown menus
const REQUEST_STATUS_CHOICES = [
  {
    value: STARTED,
    label: $gettext('Started'),
  },
  {
    value: SUBMITTED,
    label: $gettext('Submitted'),
  },
  {
    value: DECLINED,
    label: $gettext('Declined'),
  },
  {
    value: APPROVED,
    label: $gettext('Approved'),
  },
]

const REQUEST_SUBMITTED_STATUSES = [
  {
    value: SUBMITTED_NEW,
    label: $gettext('Newly Submitted'),
  },
  {
    value: SUBMITTED_AWAITING_ADMIN_REPLY,
    label: $gettext('Awaiting Admin Reply'),
  },
  {
    value: SUBMITTED_AWAITING_USER_REPLY,
    label: $gettext('Awaiting User Reply'),
  },
]

/*
 * Request Declined Reasons
 */
const DUPLICATE = 'DUPLICATE'
const SUSPECTED_FRAUD = 'SUSPECTED_FRAUD'
const NOT_ELIGIBLE = 'NOT_ELIGIBLE'
const OVER_INDIVIDUAL_LIMIT = 'OVER_INDIVIDUAL_LIMIT'
const DOCUMENTATION_INSUFFICIENT_OR_UNCLEAR = 'DOCUMENTATION_INSUFFICIENT_OR_UNCLEAR'
const WITHDRAWN = 'WITHDRAWN'

const REASON_DECLINED_LIST = [
  DUPLICATE,
  SUSPECTED_FRAUD,
  NOT_ELIGIBLE,
  OVER_INDIVIDUAL_LIMIT,
  DOCUMENTATION_INSUFFICIENT_OR_UNCLEAR,
  OTHER,
]

// Use this for dropdown menus
const REASON_DECLINED_CHOICES = [
  {
    value: DUPLICATE,
    label: $gettext('Duplicate'),
  },
  {
    value: SUSPECTED_FRAUD,
    label: $gettext('Suspected Fraud'),
  },
  {
    value: NOT_ELIGIBLE,
    label: $gettext('Not Eligible'),
  },
  {
    value: OVER_INDIVIDUAL_LIMIT,
    label: $gettext('Over Individual Limit'),
  },
  {
    value: DOCUMENTATION_INSUFFICIENT_OR_UNCLEAR,
    label: $gettext('Documentation (none, insufficient, unclear)'),
  },
  {
    value: WITHDRAWN,
    label: $gettext('Withdrawn'),
  },
  {
    value: OTHER,
    label: $gettext('Other'),
  },
]

/**
 * Documentation Types
 */
const EVENT = 'EVENT'
const EXPENSE = 'EXPENSE'

/**
 * Nomination statuses
 */

const INCOMPLETE = "INCOMPLETE"
const NOMINATED = "NOMINATED"
const ACCEPTED = "ACCEPTED"
const DENIED = "DENIED"
const REMOVED = "REMOVED"
const PENDING_EMAIL_VERIFICATION = "PENDING_EMAIL_VERIFICATION"
const PENDING_EMAIL_VERIFICATION_NOTIFIED = "PENDING_EMAIL_VERIFICATION_NOTIFIED"
const EMAIL_VERIFIED = "EMAIL_VERIFIED"
const COMPLETE = "COMPLETE"

const NOMINATION_STATUS_CHOICES = [
  {
    value: INCOMPLETE,
    label: $gettext('Incomplete'),
  },
  {
    value: NOMINATED,
    label: $gettext('Nominated'),
  },
  {
    value: ACCEPTED,
    label: $gettext('Accepted'),
  },
  {
    value: DENIED,
    label: $gettext('Denied'),
  },
  {
    value: REMOVED,
    label: $gettext('Removed'),
  },
  {
    value: PENDING_EMAIL_VERIFICATION,
    label: $gettext('Pending Email Verification'),
  },
  {
    value: PENDING_EMAIL_VERIFICATION_NOTIFIED,
    label: $gettext('Pending Email Verification (GM Notified)'),
  },
  {
    value: EMAIL_VERIFIED,
    label: $gettext('Email Verified'),
  },
  {
    value: COMPLETE,
    label: $gettext('Completed'),
  },
  {
    value: APPROVED,
    label: $gettext('Approved'),
  },
]

export default {
  STARTED,
  SUBMITTED,
  DECLINED,
  APPROVED,
  PARTIALLY_APPROVED,
  PARTIALLY_APPROVED_PENDING,
  REQUEST_STATUS_LIST,
  REQUEST_STATUS_CHOICES,
  OPEN_REQUEST_STATUSES,
  CLOSED_REQUEST_STATUSES,
  DUPLICATE,
  SUSPECTED_FRAUD,
  NOT_ELIGIBLE,
  OVER_INDIVIDUAL_LIMIT,
  DOCUMENTATION_INSUFFICIENT_OR_UNCLEAR,
  OTHER,
  REASON_DECLINED_LIST,
  REASON_DECLINED_CHOICES,
  EVENT,
  EXPENSE,
  SUBMITTED_NEW,
  SUBMITTED_AWAITING_USER_REPLY,
  SUBMITTED_AWAITING_ADMIN_REPLY,
  REQUEST_SUBMITTED_STATUSES,
  PAYOUT_TYPE_LIST,
  PAYOUT_TYPE_CHOICES,
  PAYPAL,
  NOMINATION_STATUS_CHOICES,
}
